import { differenceInSeconds } from 'date-fns/differenceInSeconds';
import { differenceInMinutes } from 'date-fns/differenceInMinutes';
import { differenceInHours } from 'date-fns/differenceInHours';
import { differenceInDays } from 'date-fns/differenceInDays';
import { differenceInMonths } from 'date-fns/differenceInMonths';
import { differenceInYears } from 'date-fns/differenceInYears';
import { plural } from '@lingui/core/macro';

export function formatEventTimeDiff(laterEvent: Date, earlierEvent: Date) {
  const diffInYears = differenceInYears(laterEvent, earlierEvent);
  if (diffInYears > 0) {
    return plural(diffInYears, {
      other: `#y`,
    });
  }
  const diffInMonths = differenceInMonths(laterEvent, earlierEvent);
  if (diffInMonths > 0) {
    return plural(diffInMonths, {
      other: `#m`,
    });
  }
  const diffInDays = differenceInDays(laterEvent, earlierEvent);
  if (diffInDays > 0) {
    return plural(diffInDays, {
      other: `#d`,
    });
  }
  const diffInHours = differenceInHours(laterEvent, earlierEvent);
  if (diffInHours > 0) {
    return plural(diffInHours, {
      other: `#h`,
    });
  }
  const diffInMinutes = differenceInMinutes(laterEvent, earlierEvent);
  if (diffInMinutes > 0) {
    return plural(diffInMinutes, {
      other: `#min`,
    });
  }
  const diffInSeconds = differenceInSeconds(laterEvent, earlierEvent);
  return plural(diffInSeconds, {
    other: `#s`,
  });
}
